<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="视频信息"
    @ok="$emit('onCancel')"
    @cancel="$emit('onCancel')"
  >
    <video
      :src="videoUrl"
      controls
      width="650"
    />
  </a-modal>
</template>
<script>
export default{
  props: ['visible', 'videoUrl'],
  data(){
    return{

    };
  },
  mounted(){
  },
  methods: {
  },
};
</script>
<style lang="
      less"
      scoped
    />
  </a-modal>
</template></a-modal></video></style>